<div class="write-main">
  <img class="close-icon cursor-pointer" (click)="closePopUp()" src="assets/icons/close_black_round.png">
  <div class="pop-up-heading">
    Write to Us
  </div>
  <div class="pop-up-info">
    Please fill the details below and we will get in touch with you
  </div>
  <form (ngSubmit)="f.form.valid && processForm()" #f="ngForm" novalidate>
    <div class="col-lg-12 row">

      <div class="col-lg-6">
        <label class="lbl-text">First Name <span class="mandatory"> *</span></label><br>
        <input type="text" [pattern]="alphaPattern" minlength="1" maxlength="32" [(ngModel)]="firstName"
          autocomplete="off" name="first" #name="ngModel" required>
        <div *ngIf="f.submitted && name.invalid" class="error-text">
          <div *ngIf="name.errors?.['required']">First name is required</div>
          <div *ngIf="name.errors?.['pattern']">First name not valid.</div>
        </div>
      </div>
      <div class="col-lg-6">
        <label class="lbl-text">Last Name <span class="mandatory"> *</span></label><br>
        <input type="text" [pattern]="alphaPattern" minlength="1" maxlength="32" [(ngModel)]="lastName"
          autocomplete="off" name="last" #lname="ngModel" required>
        <div *ngIf="f.submitted && lname.invalid" class="error-text">
          <div *ngIf="lname.errors?.['required']">Last name is required</div>
          <div *ngIf="lname.errors?.['pattern']">First name not valid.</div>
        </div>
      </div>
      <div class="col-lg-6">
        <label class="lbl-text">Mobile <span class="mandatory"> *</span></label><br>
        <input type="text" class="mobText" minlength="10" maxlength="10" [pattern]="mobNumberPattern" id="mobile"
          [(ngModel)]="userData.mobileNumber" autocomplete="off" name="mobile" #mobile="ngModel" required>
        <div class="error-text">
          <div *ngIf="f.submitted && mobile.errors?.['required']">Mobile number required</div>
          <div *ngIf="mobile.errors?.['pattern']">Mobile number not valid.</div>
        </div>
      </div>
      <div class="col-lg-6">
        <label class="lbl-text">Email <span class="mandatory"> *</span></label><br>
        <input type="text" minlength="5" maxlength="64" [(ngModel)]="userData.emailId" autocomplete="off" name="email"
          #email="ngModel" required email>
        <div *ngIf="f.submitted && email.invalid" class="error-text">
          <div *ngIf="email.errors?.['required']">Email required</div>
          <div *ngIf="email.errors?.['email']">Enter a valid email address</div>
        </div>
      </div>
      <div class="col-lg-6">
        <label class="lbl-text">City <span class="mandatory"> *</span></label><br>
        <select [(ngModel)]="userData.city" #city="ngModel" name="city" required>
          <option value="">Select your city</option>
          <option *ngFor="let item of cityList" [value]="item.cityName">{{item.cityName | titlecase}}</option>
        </select>
        <span class="mandatory" *ngIf="city.invalid && city.errors?.['required']">City required</span>
      </div>
      <div class="col-lg-6">
        <label class="lbl-text">Reason <span class="mandatory"> *</span></label><br>
        <select [(ngModel)]="userData.reason" name="reason" #reason="ngModel" required>
          <option value="">Select</option>
          <option *ngFor="let item of reasonList" [value]="item">{{item}}</option>
        </select>
        <div *ngIf="f.submitted && reason.invalid" class="error-text">
          <div *ngIf="reason.errors?.['required']">Reason required</div>
        </div>
      </div>
      <div class="col-lg-12">
        <label class="lbl-text">Message </label><br>
        <mat-label>(Maximum 100 characters)</mat-label>
        <textarea rows="1" [pattern]="msgPattern" maxlength="100" name="message"
          #message="ngModel" [(ngModel)]="userData.message" autocomplete="off"></textarea>
        <div *ngIf="f.submitted && message.invalid" class="error-text">
          <div *ngIf="message.errors?.['pattern']">Invalid message.</div>
        </div>
      </div>
      <div class="col-lg-12">
        <button class="submit-button btn-spc">Submit</button>
        <div class="instructions">Fields with * marks are mandatory</div>
        <div class="instructions">Your personal details will be used only for the purpose of communicating with you and
          will not be shared with a third party.</div>
      </div>
    </div>
  </form>
</div>